/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';

import { environment } from '@env/environment';

import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import * as NProgress from 'nprogress';

import { CredentialsService } from '../utils/credentials/credentials.service';

@Injectable({
  providedIn: 'root',
})
export class TokenHandlerInterceptor implements HttpInterceptor {
  private credentialsService = inject(CredentialsService);
  /* constructor(private credentialsService: CredentialsService) {} */

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log('request', request.url);
    const savedCredentials = this.credentialsService.credentials();
    const urlRequest = request.url;
    const urlBase = environment.baseUrl;

    // log.info('TokenHandlerInterceptor', urlRequest, urlBase, urlRequest.includes(urlBase));

    NProgress.start();
    if (savedCredentials && urlRequest.includes(urlBase)) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${savedCredentials?.token}`),
      });
    }

    return next.handle(request).pipe(
      finalize(() => {
        NProgress.done();
        NProgress.remove();
      })
    );
  }
}
